<template>
  <div
    v-if="showComponent"
    class="m-constituent-metadata"
    :class="{
      'm-constituent-metadata--has-resources': relatedResourcesLinks.length
    }"
  >
    <RecordMetadataField
      v-for="(value, key) in metadata"
      ref="person-metadata-field"
      :key="key"
      :class="{
        'm-record-metadata-field--ulan': key.includes('ulan'),
        'm-record-metadata-field--ulan-names': key.includes('ulanNames')
      }"
      :label="translatePart('person_metadata.' + key)"
      :data-testid="key"
      :values="value"
      :is-table="true"
    >
      <template v-if="key == 'ulanNames'">
        <DelimitedFieldValues :values="value" :delimiter="'block'" />
        <GuiLink
          v-if="ulan.ulanNames?.length > 3"
          :href="actor.ulan.link"
          with-icon="after"
          icon-name="outbound"
        >
          {{ translate("person_metadata.allNamesLink") }}
        </GuiLink>
      </template>
    </RecordMetadataField>
    <RecordMetadataField
      v-show="relatedResourcesLinks.length > 0 || hasLinks"
      :classes="['m-constituent-metadata__related-resources']"
      :is-table="true"
      :label="translatePart('person_metadata.resources')"
    >
      <RelatedResources
        :id="actor.id"
        :links="relatedResourcesLinks"
        :exclude-external-hosts="['youtu']"
        :has-heading="false"
        :classes="['m-constituent-metadata__related-resources']"
        @has-content="hasLinks = $event"
      />
    </RecordMetadataField>
  </div>
</template>

<script>
import {
  useLocalization,
  RecordMetadataField,
  GuiLink,
  DelimitedFieldValues
} from "@thegetty-private/getty-ui";
import RelatedResources from "@/components/molecules/relatedResources/index.vue";

export default {
  name: "ConsituentMetadata",
  components: {
    RecordMetadataField,
    RelatedResources,
    DelimitedFieldValues,
    GuiLink
  },

  props: {
    /**
     * The transformed actor object from the store
     */
    actor: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      hasLinks: false
    };
  },
  computed: {
    /**
     * The key/value pairs to be displayed using RecordMetadataField
     * @returns {object}
     */
    metadata() {
      if (this.actor == undefined) {
        return;
      }

      return this.actor.metadata;
    },
    /**
     * ULAN key/value pairs
     * @returns {object}
     */
    ulan() {
      return this.actor?.ulan;
    },
    /**
     * Array of objects used to construct GuiLinks for the RelatedResources section
     * @returns {array}
     */
    relatedResourcesLinks() {
      return this.actor.relatedResourcesLinks;
    },
    /**
     * Checks if there is any data to display and returns whether or not to show this component
     * @returns {boolean}
     */
    showComponent() {
      if (!this.actor.metadata && !this.actor.relatedResourcesLinks) {
        return;
      }

      if (
        (this.metadata && Object.keys(this.metadata).length != 0) ||
        this.relatedResourcesLinks.length > 0
      ) {
        return true;
      }

      return false;
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
